import type { AxiosResponse } from 'axios'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import { getActiveCompanyId, getErrorMessage } from '@helpers'

import authActions from '../auth/actions'
import actions from './actions'
import * as api from './api'
import { clearAllDrafts } from './draft'
import type { MessageToAccountantPayload } from './types'

function* fetchMessageToAccountantTopicsSaga() {
  try {
    const companyId: Company['id'] = yield select(getActiveCompanyId)
    const response: AxiosResponse = yield call(api.fetchMessageToAccountantTopics, companyId)
    yield put(actions.fetchMessageToAccountantTopics.success(response.data))
  } catch {
    yield put(actions.fetchMessageToAccountantTopics.success([]))
  }
}

function* createMessageToAccountantSaga({
  payload,
  meta: { resolve, reject },
}: AsyncSagaAction<MessageToAccountantPayload>) {
  try {
    const companyId: Company['id'] = yield select(getActiveCompanyId)
    const response: AxiosResponse = yield call(api.createMessageToAccountant, companyId, payload)
    yield call(resolve, response.data)
  } catch (error) {
    const errorMsg = getErrorMessage(error)
    yield call(reject, errorMsg)
  }
}

// watcher Saga
export default function* messageToAccountantSaga() {
  yield takeLatest(actions.fetchMessageToAccountantTopics.REQUEST, fetchMessageToAccountantTopicsSaga)
  yield takeLatest(actions.createMessageToAccountant.REQUEST, createMessageToAccountantSaga)
  // The root reducer has already wiped auth by the time this runs, so there is no user id left to
  // target - every stored draft goes.
  yield takeLatest(authActions.logout.SUCCESS, clearAllDrafts)
}
